import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchTasksAvailableByOrder = (order) => apiActionCreator({
  'endpoint': `/quality-assurance/orders/${order}/tasks-available`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_TASKS_AVAILABLE,
    ActionTypes.FETCHED_TASKS_AVAILABLE,
    [
      ActionTypes.FETCHED_TASKS_AVAILABLE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchProvidersOutsourced = () => apiActionCreator({
  'endpoint': '/orders/providers/outsourced',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PROVIDERS_OUTSOURCED,
    ActionTypes.FETCHED_PROVIDERS_OUTSOURCED,
    [
      ActionTypes.FETCHED_PROVIDERS_OUTSOURCED_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchTasksForQualityAssuranceOrder = (order) => apiActionCreator({
  'endpoint': `/quality-assurance/orders/${order}/tasks/list`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_TASKS_BY_QUALITY_ASSURANCE_ORDER,
    ActionTypes.FETCHED_TASKS_BY_QUALITY_ASSURANCE_ORDER,
    [
      ActionTypes.FETCHED_TASKS_BY_QUALITY_ASSURANCE_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const manageTasksInQualityAssuranceOrder = (order, index, data = {}) => {
  return apiActionCreator({
    'endpoint': `/quality-assurance/orders/${order}/tasks/list`,
    'authenticated': true,
    'types': [
      ActionTypes.MANAGING_TASK_IN_QUALITY_ASSURANCE_ORDER,
      [
        {
          'type': ActionTypes.MANAGED_TASK_IN_QUALITY_ASSURANCE_ORDER,
          'payload': {
            index, 'action': data.action, 'outsourced': data.outsourced, 'serviceCode3': data.serviceCode3, order,
          },
        },
        (response) => MessageActions.addMessageBoxInfo(response.data.message),
      ],
      [
        ActionTypes.MANAGED_TASK_IN_QUALITY_ASSURANCE_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    data,
  });
};

export const addTaskInfo = (index, taskInfo) => ({
  'type': ActionTypes.ADD_TASK_INFO,
  'payload': {index, taskInfo},
});

export const addOutsourcedInfo = (index, outsourcedInfo) => ({
  'type': ActionTypes.ADD_OUTSOURCED_INFO,
  'payload': {index, outsourcedInfo},
});
